import React from 'react';
import {ExceptionBox} from "../components/report/fail";


class ExeptionsTrapper extends React.Component{
    constructor(props){
        super(props)
        this.state = {"hasError": false}
    }
    static getDerivedStateFromError(error) {
        console.log(error)
    // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    
    render(){
        
        return this.state.hasError?
            <ExceptionBox /> :
            this.props.children
        
    }
    
}

export default ExeptionsTrapper